import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';
import { revealRectangle } from '../../../util/animation/reveal/reveal';
import type { CtaRefType } from '../../../util/cta/cta.data';

interface ArticleHeaderRefs {
  elementRef?: RefObject<HTMLElement | null>;

  titleRef?: RefObject<HTMLHeadingElement | null>;
  categoryRef?: RefObject<HTMLDivElement | null>;
  dateRef?: RefObject<HTMLTimeElement | null>;
  headerButtonRef?: RefObject<CtaRefType | null>;
  imageHolder?: RefObject<HTMLDivElement | null>;
  gifRef?: RefObject<HTMLVideoElement | null>;

  lineRef?: RefObject<HTMLHRElement | null>;
  shareTitleRef?: RefObject<HTMLDivElement | null>;
  buttonRef?: RefObject<CtaRefType | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  {
    titleRef,
    categoryRef,
    dateRef,
    headerButtonRef,
    imageHolder,
    gifRef,
    lineRef,
    shareTitleRef,
    buttonRef,
  }: ArticleHeaderRefs,
): void {
  const categoryController = findTransitionController(categoryRef);
  const titleController = findTransitionController(titleRef);
  const shareTitleController = findTransitionController(shareTitleRef);
  const buttonController = findTransitionController(buttonRef);

  if (imageHolder?.current) {
    timeline.add(revealRectangle(imageHolder.current), 0);
  }

  if (gifRef?.current) {
    timeline.add(revealRectangle(gifRef.current), 0);
  }

  timeline.addLabel('startText', '>-0.2');

  if (categoryController) {
    timeline.add(categoryController?.getTimeline('in') as gsap.core.Timeline, 'startText');
  }
  if (titleController) {
    timeline.add(titleController?.getTimeline('in') as gsap.core.Timeline, 'startText+=0.1');
  }

  if (dateRef) {
    const dateController = findTransitionController(dateRef);
    timeline.add(dateController?.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }

  if (headerButtonRef) {
    const headerButtonController = findTransitionController(headerButtonRef);
    timeline.add(headerButtonController?.getTimeline('in') as gsap.core.Timeline, '>-=0.2');
  }

  if (lineRef?.current) {
    timeline.fromTo(
      lineRef.current,
      { scaleX: 0, transformOrigin: 'left center' },
      {
        scaleX: 1,
        clearProps: 'scaleX',
        ease: 'Quad.easeOut',
        duration: 0.5,
      },
      '>-0.2',
    );
  }

  if (shareTitleController) {
    timeline.add(shareTitleController?.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }
  if (buttonController) {
    timeline.add(buttonController?.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }
}
